export const ADHESION_STATUSES = {
  SIGNED: 'signed',
  ACTIVE: 'active',
  PAYMENT_DEFAULT: 'payment-default',
  NOTIFICATION: 'notification',
  SUSPENDED: 'suspended',
  CANCELED: 'canceled',
  CANCELED_FIRST_PAYMENT: 'canceled-first-payment',
  TERMINATED_END_DATE: 'terminated-end-date',
  TERMINATED_CLIENT: 'terminated-client',
  TERMINATED_COMPLIANCE: 'terminated-compliance',
  TERMINATED_PAYMENT: 'terminated-payment',
}

// Maps technical status → Status component type (CSS class)
export const ADHESION_STATUS_TYPE = {
  'signed': 'adhesionSigned',
  'active': 'adhesionActive',
  'payment-default': 'adhesionUnpaid',
  'notification': 'adhesionUnpaid',
  'suspended': 'adhesionInactive',
  'canceled': 'adhesionInactive',
  'canceled-first-payment': 'adhesionInactive',
  'terminated-end-date': 'adhesionInactive',
  'terminated-client': 'adhesionInactive',
  'terminated-compliance': 'adhesionInactive',
  'terminated-payment': 'adhesionInactive',
}

// Statuses that should grey out the contract card (nice to have)
export const INACTIVE_ADHESION_STATUSES = [
  'suspended',
  'canceled',
  'canceled-first-payment',
  'terminated-end-date',
  'terminated-client',
  'terminated-compliance',
  'terminated-payment',
]

export const isAdhesionInactive = (status) => INACTIVE_ADHESION_STATUSES.includes(status)
